import { render } from "./App.vue?vue&type=template&id=4ac59a95&lang=pug"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=4ac59a95&lang=sass"
script.render = render

export default script